const table = [   
  {
    prop: 'name_module',
    label: 'Nombre',
    minWidth: 150
  },
  {
    prop: 'url',
    label: 'URL',
    minWidth: 150
  },
  {
    prop: 'description',
    label: 'Descripción',
    minWidth: 200
  },
  {
    prop: 'parent_label',
    label: 'Padre',
    minWidth: 120
  },
  {
    prop: 'type',
    label: 'Tipo',
    minWidth: 120
  }
]

const table_plus = [
  {
    prop: 'order',
    label: 'Orden',
  },
  {
    prop: 'level',
    label: 'Nivel',
  },
  {
    prop: 'value',
    label: 'Valor',
  },
  {
    prop: 'roles_names',
    label: 'Perfiles',
  }
]

export default [table, table_plus]
